import { Component, OnInit, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { ApplicationName } from 'src/app/models/ApplicationName';
import { ApplicationNamePipe } from 'src/app/shared/pipe/application-name/user-group.pipe';
import { UserGroupTokenMapping } from 'src/app/models/userGroupTokenMapping';
import { Tokens } from 'src/app/models/tokens';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-managegroup',
  templateUrl: './managegroup.component.html',
  styleUrls: ['./managegroup.component.css']
})
export class ManagegroupComponent implements OnInit {

  nogroups: boolean = false;
  userCount: number = 0;
  isShowNotificationAlert: boolean;
  showAlertMessage: string;
  isShowNotificationSuccess: boolean;
  showSuccessMessage: string;
  isShowNotificationError: boolean;
  showErrorMessage: string;
  constructor(private _user: UserService) { }
  users: any;
  groups = [];
  newGroup: string = "";
  groupExists: boolean = false;
  checkedPermissionView = [];
  checkedPermissionDelete = [];
  checkedPermissionModify = [];
  checkedPermissionUpload = [];
  checkedPermissionDownload = [];
  permission: string[] = []
  masterUsers: any;
  applications: any = [];
  doprdownExpansions: any = {};
  isExtensionExpanded: boolean = false;
  ViewExpanded: boolean = false;
  DeleteExpanded: boolean = false;
  ModifyExpanded: boolean = false;
  DownloadExpanded: boolean = false;
  UploadExpanded: boolean = false;
  currentApp: string;
  currentAppId: string;
  appId: string;
  prevApp: string;
  searchWord: string = '';
  user: any = {};
  group: UserGroupTokenMapping;
  groupToDelete: any = '';
  isMailError: boolean = false;
  apiReturnMessage: string = "";
  isAscending: boolean = true;
  sortColumn: string = 'name';//default sorting column from backend is name.
  prevSortColumn: string = 'name';
  isAdminUser: boolean = false;
  isSuperUser: boolean = false;
  modifySuperAccess: boolean;
  noAccessToApplication: boolean;
  userGroups: Array<UserGroupTokenMapping>;
  superUserGroup: string;
  modifyUserGroups: Array<UserGroupTokenMapping>;
  VALUsers: any = {};
  @ViewChildren("ViewCheckboxes") viewCheckboxes: QueryList<ElementRef>;
  @ViewChildren("UploadCheckboxes") uploadCheckboxes: QueryList<ElementRef>;
  @ViewChildren("DeleteCheckboxes") deleteCheckboxes: QueryList<ElementRef>;
  @ViewChildren("DownloadCheckboxes") downloadCheckboxes: QueryList<ElementRef>;
  @ViewChildren("ModifyCheckboxes") modifyCheckboxes: QueryList<ElementRef>;

  ngOnInit() {
    this.checkIfUserIsAdmin();
    this.getExternalApplications();
    this.initialiseUser();//user object for Adding and Modifying a user
    this.doprdownExpansions.application = false;
    this.doprdownExpansions.addGroup = false;
    this.permission = ["Self Commercial", "Self Non-Commercial", "Others Commercial", "Others Non-Commercial"];
  }

  checkIfUserIsAdmin() {
    this.isAdminUser = false;
    this._user.loggendInUser.applicationName.forEach((app) => {
      if (app.userGroup == 'Admin') {
        this.isAdminUser = true;
      }
    });
  }

  DeleteAccordianOpen() {
    setTimeout(() => {
      this.DeleteExpanded = true;
    });
  }

  ViewAccordianOpen() {
    setTimeout(() => {
      this.ViewExpanded = true;
    });
  }

  DownloadAccordianOpen() {
    setTimeout(() => {
      this.DownloadExpanded = true;
    });
  }

  ModifyAccordianOpen() {
    setTimeout(() => {
      this.ModifyExpanded = true;
    });
  }

  UploadAccordianOpen() {
    setTimeout(() => {
      this.UploadExpanded = true;
    });
  }

  checkIfUserIsSuperUser(selectedApplicationId: string) {
    this.isSuperUser = false;
    this._user.loggendInUser.applicationName.forEach((app) => {
      if (app.application == selectedApplicationId && app.userGroup == 'SuperUser') {
        this.isSuperUser = true;
      }
    });
  }

  //searches the user list with the searchword .
  //to reset the search call search(null,'');
  search(event: KeyboardEvent, word: string = '') {
    this.searchWord = event == null ? word : event.target['value'];
    this.users = [];
    this.masterUsers.forEach(element => {
      element.userGroup = element.userGroup == null ? "" : element.userGroup;
    });
    this.masterUsers.forEach(user => {
      if (user.userEmailId.toLowerCase().includes(this.searchWord.toLowerCase()) || user.name.toLowerCase().includes(this.searchWord.toLowerCase())
        || user.userGroup.toLowerCase().includes(this.searchWord.toLocaleLowerCase())) //if search word contains anything from Emailid,name,usergroup it would then show up in the grid.
        this.users.push(user);
    });
    this.doActualSort();//keeping sort intact after clearing search.
  }

  // getGroups2(app: any, aapName?: string) {
  //   this.groups.push({ Group: "TestUser", Tokens: [{ Function: "Modify", Permissions: [["Self", "Commercial"], ["Self", "Non-Commercial"], ["Others", "Commercial"], ["Others", "Non-Commercial"]] }, { Function: "Delete", Permissions: [["Self", "Commercial"], ["Self", "Non-Commercial"], ["Others", "Commercial"], ["Others", "Non-Commercial"]] }, { Function: "View", Permissions: [["Self", "Commercial"], ["Self", "Non-Commercial"], ["Others", "Commercial"], ["Others", "Non-Commercial"]] }, { Function: "Upload", Permissions: [["Self", "Commercial"], ["Self", "Non-Commercial"]] }, { Function: "Download", Permissions: [["Self", "Commercial"], ["Self", "Non-Commercial"], ["Others", "Commercial"], ["Others", "Non-Commercial"]] }], ApplicationName: ["5e54a563506f422cb09ad0e6"] });
  //   console.log(this.groups);
  // }

  getGroups(app: any, aapName?: string) {
    this.isAdminUser = false;
    this.isSuperUser = false;
    this.VALUsers = [];
    this.users = [];

    if (aapName === "VAL" || app === "VAL Web App") {
      this.checkIfUserIsAdmin();
      this.appId = "VAL Web App";
      this.getUserGroupsByApplicationId("VAL Web App");
      this.prevApp = app;//to avoid calling api for same application selection.
    }
    else {
      this.checkIfUserIsSuperUser(app);
      if (app == this.prevApp)//if the currently clicked application is same as the one before clicked.
        return;
      this.appId = app;
      this.getUserGroupsByApplicationId(this.appId);
      this.prevApp = app;//to avoid calling api for same application selection.
    }
  }

  getExternalApplications(currAppId = "") {
    this._user.getExternalApplications().subscribe((res) => {
      this.applications = [];
      var userApps = JSON.parse(sessionStorage.userinfo).applicationName;
      var appIds = [];
      userApps.forEach(element => {
        appIds.push(element.application);
      });
      if (!this.isAdminUser) {
        res.forEach(element => {
          if (appIds.includes(element._id))
            this.applications.push(element);//to show only apps user have permission to
        });
      } else {
        this.applications = res;
        this.applications.forEach(element => {
          if (element.name == "VAL")
            element._id = "VAL Web App";
        });
      }
      sessionStorage.setItem("Applications", JSON.stringify(this.applications));
      console.log(this.applications);
      if (currAppId.length > 0) {
        this.currentAppId = currAppId;
        this.applications.forEach(element => {
          if (element._id == currAppId) {
            this.currentApp = element.name;
          }
        });
      }
      else {
        this.currentApp = this.applications[0].name;
        this.currentAppId = this.applications[0]._id;
      }
      this.prevApp = '';
      this.getGroups(this.currentAppId);//fetches users for the application specified.
      // this.getGroups2(this.applications[0]._id);
    });
  }

  getUserGroupsByApplicationId(app: string) {
    this._user.getUserGroupsByApplicationId(this._user.loggendInUser.userEmailId, app).subscribe((result) => {
      this.nogroups = false;
      this.userGroups = result;
      let grp = this.userGroups.find(x => x.group == "SuperUser") == undefined ? this.userGroups.find(x => x.group == "Admin") : this.userGroups.find(x => x.group == "SuperUser");
      this.superUserGroup = grp.group;
      this.modifyUserGroups = JSON.parse(JSON.stringify(this.userGroups));

      this.checkIfUserIsAdmin();
    }, (err) => {
      this.nogroups = true;
      this.modifyUserGroups = new Array<UserGroupTokenMapping>();
      // alert(err.error);
      this.alertNotification(err.error);
    });
  }


  alertNotification(message){
    this.isShowNotificationAlert = true;
    this.showAlertMessage = message;
    setInterval(()=>{
      this.isShowNotificationAlert = false;
    },5000);
  }

  successNotification(message){
    this.isShowNotificationSuccess = true;
    this.showSuccessMessage = message;
    setInterval(()=>{
      this.isShowNotificationSuccess = false;
    },5000);
  }

  errorNotification(message){
    this.isShowNotificationError = true;
    this.showErrorMessage = message;
    setInterval(()=>{
      this.isShowNotificationError = false;
    },5000);
  }

  generateData(tokens): string {
    let displayString: string = "";
    tokens.forEach(element => {
      displayString += element.function + ',';
    });
    return displayString.substring(0, displayString.lastIndexOf(','));
  }

  initialiseUser(modal: string = '') {
    this.group = new UserGroupTokenMapping();
    this.doprdownExpansions.addGroup = false;
    this.checkedPermissionView = [];
    this.checkedPermissionDelete = [];
    this.checkedPermissionModify = [];
    this.checkedPermissionUpload = [];
    this.checkedPermissionDownload = [];
    // this.ModifyExpanded = false;
    // this.ViewExpanded = false;
    // this.DeleteExpanded = false;
    // this.UploadExpanded = false;
    // this.DownloadExpanded = false;
    if (modal)
      document.querySelector('#' + modal).removeAttribute('visible');
  }

  deleteGroup(appId) {
    this._user.deleteUserGroup(this._user.loggendInUser.userEmailId, this.groupToDelete._id, appId).subscribe(res => {
      console.log(res);
      this.modifyUserGroups = this.modifyUserGroups.filter(x => x.group !== this.groupToDelete.group);
      // alert('deleted');
      this.successNotification("Group Deleted!");
      this.groupToDelete = {};
    }, err => {
      console.log(err);
    });
  }

  deleteConfirmation(group: UserGroupTokenMapping) {
    this.groupToDelete = group;
    document.getElementById('delete-confirmation').setAttribute('visible', 'true');
    this._user.fetchUserCount(this._user.loggendInUser.userEmailId, group._id, this.currentAppId).subscribe(res => {
      console.log(res);
      this.userCount = Array.from(res).length;
    }, err => {
      this.userCount = 0;
    });
  }

  //Initialise the user for modification and shows popup.
  initModify(group: UserGroupTokenMapping) {
    console.log(group);
    this.group = JSON.parse(JSON.stringify(group)); //cloning to avoid object reference issues.
    this.mapTokens(this.group.tokens);
    document.getElementById('modifyGroup').setAttribute('visible', 'true');
  }

  selection(item: string, permission: string) {
    let permissionArr = item.split(' ');
    let token = this.group.tokens.find(x => x.function == permission);
    if (token == undefined) {
      this.group.tokens.push({ function: permission, permissions: [permissionArr] });
      return;
    }
    let ind = token.permissions.findIndex(it => it.join(' ') == item);
    if (ind == -1) {
      token.permissions.push(permissionArr);
    }
    else {
      token.permissions.splice(ind, 1);
    }

    this.group.tokens = this.group.tokens.filter(x => x.permissions.length !== 0);
  }

  modifyPermissions(appId) {
    this._user.modifyUserGroup(this._user.loggendInUser.userEmailId, appId, this.group).subscribe(res => {
      this.modifyUserGroups.find(x => x.group == this.group.group).tokens = this.group.tokens;
      this.initialiseUser("modifyGroup");
      // alert("Permissions updated");
      this.successNotification("Permissions updated");
      this.getExternalApplications(this.currentAppId);
    }, err => {
      console.log(err);
    });
  }

  addNewGroup(name, appId) {
    let arr: Array<string> = [];
    let newGrp: UserGroupTokenMapping = new UserGroupTokenMapping();
    arr.push(appId);
    newGrp.applicationName = arr;
    newGrp.group = name;
    newGrp.tokens = [];

    console.log(newGrp);

    this._user.addNewUserGroup(this._user.loggendInUser.userEmailId, newGrp, appId).subscribe(res => {
      // alert("New Group Added");
      this.successNotification("New Group Added");
      this.newGroup = "";
      this.getExternalApplications(this.currentAppId);
    }, err => {
      // alert(err.error);
      this.errorNotification(err.error);
    });
  }

  randomString(length, chars): string {
    let result = '';
    for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  mapTokens(tokens: Tokens[]) {
    tokens.forEach(token => {
      switch (token.function) {
        case "View": {
          token.permissions.forEach(item => this.checkedPermissionView.push(item.join(' ')));
          break;
        }
        case "Delete": {
          token.permissions.forEach(item => this.checkedPermissionDelete.push(item.join(' ')));
          break;
        }
        case "Upload": {
          token.permissions.forEach(item => this.checkedPermissionUpload.push(item.join(' ')));
          break;
        }
        case "Download": {
          token.permissions.forEach(item => this.checkedPermissionDownload.push(item.join(' ')));
          break;
        }
        case "Modify": {
          token.permissions.forEach(item => this.checkedPermissionModify.push(item.join(' ')));
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  checkModifySuperAccess(userDetails: any) {
    this.modifySuperAccess = false;
    userDetails.applicationName.forEach((app: ApplicationName) => {
      if (app.application == this.appId) {
        if (app.userGroup == "SuperUser" || app.userGroup == "Admin") {
          this.modifySuperAccess = true;
        }
      }
    });
  }

  modifyUser() {
    // alert("modified");
    this.alertNotification('modified');
    // var applicationArray = {};
    // this.user.applicationName.forEach((elem) => {
    //   if (elem.application == this.appId) {
    //     elem.userGroup = this.user.userGroup
    //     applicationArray = elem;
    //   }
    // });
    // this.user.applicationName = [];
    // this.user.applicationName.push(applicationArray);
    // this._user.modifyExternalUser(this.user).subscribe((res) => {
    //   if (res) {
    //     this.showResponse("User (" + this.user.name + ") updated successfully.", true);
    //     this.prevApp = '';
    //     this.getUsers(this.appId); //resetting and fetching the users.
    //     this.initialiseUser('modifyUser');
    //   }
    //   else {
    //     this.showResponse("User (" + this.user.name + ") updation failed.", false);
    //   }
    // });
  }

  //Add User popup : Email verification , if email already exists shows the popup and removes the entered email.
  setAddEmail(ev) {
    this.user.userEmailId = ev.target['value'];
    this.masterUsers.forEach(element => {
      if (element.userEmailId.toLowerCase() == this.user.userEmailId.toLowerCase()) {
        document.getElementById("EmailExistsPopup").setAttribute("visible", "true");
        this.user.userEmailId = "";
        ev.target["value"] = "";
      }
    });
    this.isMailError = !this.isEmail(this.user.userEmailId);
  }

  setAddGroup(ev) {
    this.groupExists = false;
    this.newGroup = ev.target.value;
    this.modifyUserGroups.forEach(ele => {
      if (ele.group.toLowerCase() == this.newGroup.toLowerCase()) {
        this.groupExists = true;
      }
    });
  }

  //Email regex
  isEmail(search: string): boolean {
    var serchfind: boolean;
    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    serchfind = regexp.test(search);
    console.log(serchfind);
    return serchfind;
  }

  //for handling the X icon in the search input box.
  isReset(ev) {
    if (ev.target.value == "")
      this.search(null, '');
  }

  showResponse(message: string, isSuccess: boolean) {
    this.apiReturnMessage = message;
    if (isSuccess)
      document.getElementById("SuccessPopup").setAttribute("visible", "true");
    else
      document.getElementById("FailurePopup").setAttribute("visible", "true");
  }

  sortUser(sortColumn: string) {
    this.sortColumn = sortColumn;
    if (this.prevSortColumn == this.sortColumn) //if column to be sorted is same as previously sorted column then toggle sort direction
      this.isAscending = !this.isAscending;
    else {
      //if column to be sorted is new then make sort direction ascending and set previous sort column to current column.
      this.isAscending = true;
      this.prevSortColumn = sortColumn;
    }
    this.doActualSort();
  }
  doActualSort() {
    this.users.forEach(element => {
      if (element.name == null)
        element.name = "";
    });
    this.users.sort((valA, valB) => {
      if (this.isAscending)
        return valA[this.sortColumn].toLowerCase().charCodeAt(0) - valB[this.sortColumn].toLowerCase().charCodeAt(0);
      else
        return valB[this.sortColumn].toLowerCase().charCodeAt(0) - valA[this.sortColumn].toLowerCase().charCodeAt(0);
    });
  }

}
